import SeoPageLayout from "@/components/SeoPageLayout";

const WystepKabaretowyKrakow = () => (
  <SeoPageLayout title="Występ kabaretowy Kraków - kabaret na event w królewskim mieście">
    <p>
      Kraków to nie tylko dawna stolica Polski, ale także jedno z najważniejszych centrów eventowych w kraju. Występ kabaretowy w Krakowie to doskonały sposób na urozmaicenie firmowego wydarzenia w mieście o bogatej tradycji kabaretowej.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kraków - miasto kabaretowej tradycji</h2>
    <p>
      Kraków to kolebka polskiego kabaretu. To właśnie tu powstał legendarny Zielony Balonik, a tradycja kabaretowa sięga początków XX wieku. Zamawiając kabaret na event w Krakowie, wpisujesz się w ponad stuletnią tradycję krakowskiego humoru i rozrywki.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Eventy firmowe w Krakowie</h2>
    <p>
      Kraków przyciąga firmy z całej Polski i Europy - wiele międzynarodowych korporacji ma tu swoje siedziby i centra usług wspólnych. Eventy firmowe w Krakowie odbywają się regularnie i wymagają atrakcji na najwyższym poziomie. Kabaret idealnie wpisuje się w ten standard.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Gdzie zamówić kabaret w Krakowie?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Hotele i sale konferencyjne - Sheraton, Hilton, Galaxy, ICE Kraków</li>
      <li>Restauracje w Rynku i okolicach - klimatyczne przestrzenie w sercu miasta</li>
      <li>Zamki i pałace w okolicach Krakowa - Niepołomice, Pieskowa Skała</li>
      <li>Centra kongresowe - ICE Kraków, EXPO Kraków</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na event w Krakowie i okolicach</h2>
    <p>
      Realizujemy występy kabaretowe na terenie całej Małopolski - w Krakowie, Wieliczce, Zakopanem, Nowym Sączu i innych miastach regionu. Niezależnie od lokalizacji, zapewniamy ten sam wysoki poziom profesjonalizmu i rozrywki.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Zamów występ kabaretowy w Krakowie</h2>
    <p>
      Skontaktuj się z nami, aby zarezerwować kabaret na Twój event w Krakowie. Przygotujemy ofertę dopasowaną do Twojego wydarzenia, lokalizacji i budżetu.
    </p>
  </SeoPageLayout>
);

export default WystepKabaretowyKrakow;
